import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { COLLECTIONS, CATEGORIES } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const Collections = () => (
  <section id="collections" data-testid="collections-section" className="py-20 md:py-32 bg-ivory scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHeading
          chapter="03"
          overline="Our Collections"
          title="Crafted for Every Occasion"
          description="Explore our signature collections in the showroom — each piece chosen for its craftsmanship, purity and design."
        />
        <Reveal delay={0.15} className="hidden md:block mb-20">
          <p className="text-xs tracking-[0.25em] uppercase text-charcoal/40">Showcase only · Visit us to purchase</p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-12 gap-5 -mt-4 md:-mt-8">
        {COLLECTIONS.map((c, i) => (
          <Reveal key={c.name} delay={0.06 * (i % 3)} className={`${c.span} group`}>
            <article
              data-testid={`collection-card-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative h-[340px] md:h-[400px] overflow-hidden rounded-sm cursor-pointer"
              onClick={() => scrollToId("contact")}
            >
              <img
                src={c.image}
                alt={c.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-royal-deep/90 via-royal-deep/25 to-transparent" aria-hidden="true" />
              <div className="absolute inset-x-0 bottom-0 p-7">
                <h3 className="font-serif text-2xl md:text-3xl text-ivory">{c.name}</h3>
                <p className="mt-1.5 text-sm font-light text-ivory/70">{c.desc}</p>
                <span
                  data-testid={`collection-explore-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className="mt-4 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-gold font-medium"
                >
                  Explore Collection
                  <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1.5" />
                </span>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20">
        <div className="flex items-center gap-4 mb-8">
          <span className="h-px w-10 bg-gold/60" aria-hidden="true" />
          <h3 className="text-xs tracking-[0.25em] uppercase font-medium text-royal">Shop by Category</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {CATEGORIES.map((cat, i) => (
            <Reveal key={cat.name} delay={0.06 * i}>
              <button
                data-testid={`category-${cat.name.toLowerCase()}`}
                onClick={() => scrollToId("gallery")}
                className="group block w-full text-left"
              >
                <div className="relative aspect-square overflow-hidden rounded-sm">
                  <img
                    src={cat.image}
                    alt={cat.alt}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-royal-deep/0 group-hover:bg-royal-deep/20 transition-colors duration-500" aria-hidden="true" />
                </div>
                <p className="mt-3 font-serif text-lg text-royal-deep group-hover:text-gold-muted transition-colors duration-300">
                  {cat.name}
                </p>
              </button>
            </Reveal>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
